<template>
  <div class="questions pt-5 mt-5">
    <div class="container mt-5">
      <div class="row">
        <div class="col-auto">
          <div class="form-group">
            <fieldset>
              <select name="selectedEvent" class="form-control" v-model="selectedEvent" @change="selectedEventChanged">
                <option :value="null">Select event</option>
                <option :value="event.id" v-for="event in events" :key="`eventSelect-${event.id}`">{{ event.header }}</option>
              </select>
            </fieldset>
          </div>
        </div>
      </div>

      <div class="row" v-if="currentEvent" :key="selectedEvent">
        <div class="col-12">
          <div class="btn-group mb-3">
            <button class="btn" :class="{ 'btn-secondary': view == 'active', 'btn-outline-secondary': view != 'active' }" @click="setView('active')">Active</button>
            <button class="btn" :class="{ 'btn-secondary': view == 'removed', 'btn-outline-secondary': view != 'removed' }" @click="setView('removed')">Removed</button>
          </div>

          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Question</th>
                <th class="text-right">Added</th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredQuestions.length == 0">
                <td colspan="4" class="text-center">No questions found. :(</td>
              </tr>
              <tr v-for="question in filteredQuestions" :key="question.id">
                <td>{{ question.name }}</td>
                <td>{{ question.question }}</td>
                <td class="text-right">{{ $DateTime.fromJSDate(question.created.toDate(), { locale: "sv-SE" }).toLocaleString($DateTime.DATETIME_SHORT_WITH_SECONDS) }}</td>
                <td class="text-right">
                  <button type="button" class="btn btn-sm btn-success" @click="updateDeleted(question, false)" v-if="question.deleted">Activate</button>
                  <button type="button" class="btn btn-sm btn-danger" @click="updateDeleted(question, true)" v-else>Remove</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "questions",
    data() {
      return {
        questions: [],
        events: [],
        selectedEvent: null,
        currentEvent: null,
        view: "active"
      }
    },
    computed: {
      filteredQuestions() {
        let result = []

        if(this.view == "active") {
          result = this.questions.filter((question) => !question.deleted)
        } else {
          result = this.questions.filter((question) => question.deleted)
        }

        return result
      }
    },
    methods: {
      async setView(view) {
        await this.getQuestions()

        this.view = view
      },
      async getQuestions() {
        let questionsRef = await firebase.firestore().collection(`questions`).where("eventId", "==", this.selectedEvent).orderBy("created", "asc")
        let questions = await questionsRef.get()

        this.questions = await questions.docs.map((doc) => {
          return Object.assign({}, { id: doc.id }, doc.data())
        })
      },
      async selectedEventChanged() {
        this.questions = []
        this.currentEvent = null

        if(this.selectedEvent) {
          let event = this.events.find((event) => event.id == this.selectedEvent)
          let object = {}

          await this.getQuestions()

          this.currentEvent = Object.assign({}, event, object)
        }
      },
      async updateDeleted(question, bool) {
        await firebase.firestore().collection(`questions`).doc(question.id).update({ deleted: bool })
        await this.getQuestions()
      }
    },
    async mounted() {
      await this.$bind("events", firebase.firestore().collection(`events`).orderBy("eventStart"))
    }
  }
</script>